module.exports = __webpack_public_path__ + "img/main-q-new.9b6a7b26.png";